import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function to check if a value is unique within a provided set of values.
 *
 * @param {string[]} values - Array of numbers to validate uniqueness against.
 * @return {ValidatorFn} A function that takes an AbstractControl and returns a ValidationErrors object if the value is not unique
 * or null if it passes validation.
 */
export function uniqueValueValidator(values: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return { required: true };
    }

    // no double
    if (values.includes(value.trim().toLowerCase())) {
      return { notUnique: true };
    }

    return null; // If all checks pass, return null (no errors)
  };
}
